import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { EURateDisclaimer } from 'components/PaymentOptions/components/SinglePaymentOptions/components/EURateDisclaimer/EURateDisclaimer';
import type { RootState } from 'reducers/types';
import { shouldShowEURateDisclaimer } from 'selectors/entities/offers/offers';

type EURateDisclaimerContainerProps = ConnectedProps<typeof connector>;

function Wrapper({ isVisible }: EURateDisclaimerContainerProps) {
  if (!isVisible) {
    return null;
  }

  return <EURateDisclaimer />;
}

Wrapper.displayName = 'EURateDisclaimerContainer';

const mapStateToProps = (state: RootState) => ({
  isVisible: shouldShowEURateDisclaimer(state),
});

const connector = connect(mapStateToProps);

const EURateDisclaimerContainer = connector(Wrapper);

export { EURateDisclaimerContainer };
